import { dvIcons } from '../lib/dvIcons.js';

/** Логотип-«вітер» Хронік Альбіону (не з icons.json). Спільний для шапки й героя. */
export function WindMark({ size = 20, stroke = 1.7, color = '#fff', className }: {
  size?: number; stroke?: number; color?: string; className?: string;
}): JSX.Element {
  return (
    <svg className={className} viewBox="0 0 24 24" width={size} height={size} fill="none"
      stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 8h10.5a2.8 2.8 0 1 0-2.8-2.8" />
      <path d="M3 12h14a2.8 2.8 0 1 1-2.8 2.8" />
      <path d="M3 16h8.5a2.4 2.4 0 1 1-2.4 2.4" />
    </svg>
  );
}

interface Props {
  name: string;
  size?: number;
  stroke?: number;
  color?: string;
  className?: string;
}

/**
 * Рендерить SVG-іконку з дизайн-родини «Хроніки Альбіону» (icons.json).
 * 24×24, без заливки, штрих — currentColor, круглі завершення.
 */
export function DvIcon({ name, size = 22, stroke = 1.7, color = 'currentColor', className }: Props): JSX.Element | null {
  const inner = dvIcons[name];
  if (!inner) return null;
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: inner }}
    />
  );
}
